import _ButterflyEffectThumbnail from "./butterfly-effect.png";
import _ILearnThumbnail from "./ilearn.png";
import _TheButterflyEffectThumbnail from "./the-butterfly-effect.png";
import _VaultThumbnail from "./vault.png";
import _WhyIStartedProgrammingThumbnail from "./why-i-started-programming.png";
import _VodalogicThumbnail from "./vodalogic.png";
import _LearningMoreByDoingLessThumbnail from "./learning-more-by-doing-less.png";
import _WhyLeaveTownThumbnail from "./why-leave-town.png";
import _WhyImScaredAboutTheFutureOfAI from "./why-im-scared-about-the-future-of-ai.png";
import _DLKaggleThumbnail from "./dl-kaggle.png";
import _FlatlandChallengeThumbnail from "./flatland-challenge.png";
import _PacmanCTFThumbnail from "./pacman-ctf.png";
import _SparsityInterpretabilityThumbnail from "./sparsity-interpretability.png";
import _UpdateMyCurrentViewsOnAISafetyThumbnail from "./update-my-current-views-on-ai-safety.jpg";
import _DefiningTheWatermarkingProblemThumbnail from "./monash-logo-mono.png";

export const ButterflyEffectThumbnail = _ButterflyEffectThumbnail;
export const ILearnThumbnail = _ILearnThumbnail;
export const TheButterflyEffectThumbnail = _TheButterflyEffectThumbnail;
export const VaultThumbnail = _VaultThumbnail;
export const WhyIStartedProgrammingThumbnail = _WhyIStartedProgrammingThumbnail;
export const VodalogicThumbnail = _VodalogicThumbnail;
export const LearningMoreByDoingLessThumbnail =
  _LearningMoreByDoingLessThumbnail;
export const WhyLeaveTownThumbnail = _WhyLeaveTownThumbnail;
export const WhyImScaredAboutTheFutureOfAIThumbnail =
  _WhyImScaredAboutTheFutureOfAI;
export const UpdateMyCurrentViewsOnAISafetyThumbnail =
  _UpdateMyCurrentViewsOnAISafetyThumbnail;
export const DefiningTheWatermarkingProblemThumbnail =
  _DefiningTheWatermarkingProblemThumbnail;
export const DLKaggleThumbnail = _DLKaggleThumbnail;
export const FlatlandChallengeThumbnail = _FlatlandChallengeThumbnail;
export const PacmanCTFThumbnail = _PacmanCTFThumbnail;
export const SparsityInterpretabilityThumbnail =
  _SparsityInterpretabilityThumbnail;
